import { render } from "./LinkedIn.vue?vue&type=template&id=c1bcd79a"
const script = {}

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__